import { FormControl, InputLabel, MenuItem } from 'components/ui';
import { SelectFullWidth } from 'components/styles_components/select';
import { FormattedMessage } from 'react-intl';
import Permission from 'utils/permission';

const PERM = Permission();

const RoleSelect = (field) => {
  return (
    <FormControl fullWidth margin={field.margin}>
      <InputLabel id={`${field.name}-label`}>{field.label}</InputLabel>
      <SelectFullWidth
        name={field.name}
        id={field.id}
        label={field.label}
        labelId={`${field.name}-label`}
        onChange={field.onChange}
        onBlur={field.onBlur}
        value={field.value}
        error={field.error}
      >
        <MenuItem value={PERM.VIEWER}>
          <FormattedMessage id="user.role.viewer" />
        </MenuItem>
        <MenuItem value={PERM.INSPECTOR}>
          <FormattedMessage id="user.role.inspector" />
        </MenuItem>
        <MenuItem value={PERM.ADMIN}>
          <FormattedMessage id="user.role.admin" />
        </MenuItem>
      </SelectFullWidth>
    </FormControl>
  );
};

export default RoleSelect;
